<ng-template #widgetDecoration let-decoration>
  <span *ngIf="api.decorationType(decoration) === 'accentDot'" class="h-2 w-2 shrink-0 rounded-full" [ngStyle]="api.decorationStyle(decoration)"></span>
  <span *ngIf="api.decorationType(decoration) === 'accentBar'" class="h-2.5 w-10 shrink-0 rounded-full" [ngStyle]="api.decorationStyle(decoration)"></span>
  <fa-icon *ngIf="api.decorationType(decoration) === 'icon'" [icon]="api.decorationIconProp(decoration)" class="shrink-0" [ngStyle]="api.decorationStyle(decoration)"></fa-icon>
  <span *ngIf="api.decorationType(decoration) === 'badge' && api.decorationBadgeLabel(decoration)" class="shrink-0 rounded-full px-1.5 py-0.5 text-[9px] font-semibold uppercase" [ngStyle]="api.decorationStyle(decoration)">
    {{ api.decorationBadgeLabel(decoration) }}
  </span>
</ng-template>

<div *ngIf="api" class="h-full min-h-0 w-full rounded-md">
  <div class="space-y-2">
    <div
      *ngFor="let row of rows; let rowIndex = index; trackBy: trackRow"
      class="flex flex-wrap items-center gap-3 rounded-md px-4 transition"
      [class.py-3]="!isHighlightedRow(rowIndex)"
      [class.py-4]="isHighlightedRow(rowIndex)"
      [class.shadow-sm]="isHighlightedRow(rowIndex)"
      [ngStyle]="topListRowStyle(row, rowIndex)">
      <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-md text-base font-semibold" [ngStyle]="rankBadgeStyle(row)">
        {{ rowIndex + 1 }}
      </span>

      <div *ngIf="api.hasSlotBinding('title')" class="min-w-0 flex-1">
        <div class="flex min-w-0 items-center gap-3">
          <span *ngIf="hasRankAccentStyle(row)" class="hidden h-2.5 w-12 shrink-0 rounded-full lg:block" [ngStyle]="rankAccentStyle(row)"></span>
          <div class="min-w-0 flex-1">
            <div *ngIf="api.showSlotLabels()" class="truncate text-xs font-normal text-slate-500">{{ api.slotColumnLabel('title') }}</div>
            <div class="mt-0.5 flex min-w-0 items-center gap-1.5 font-semibold text-slate-950" [ngStyle]="api.slotCellStyle(row, 'title')">
              <ng-container *ngFor="let decoration of api.slotLeftDecorations(row, 'title'); trackBy: trackDecoration" [ngTemplateOutlet]="widgetDecoration" [ngTemplateOutletContext]="{ $implicit: decoration }"></ng-container>
              <fa-icon *ngIf="api.slotIconName(row, 'title')" [icon]="api.slotIconProp(row, 'title')" class="shrink-0" [ngStyle]="api.slotIconStyle(row, 'title')"></fa-icon>
              <span class="min-w-0 truncate">{{ api.slotValue(row, 'title') }}</span>
              <span *ngIf="api.slotBadgeLabel(row, 'title') as titleBadge" class="shrink-0 rounded-full px-1.5 py-0.5 text-[9px] font-semibold uppercase" [ngStyle]="api.slotBadgeStyle(row, 'title')">
                {{ titleBadge }}
              </span>
              <ng-container *ngFor="let decoration of api.slotRightDecorations(row, 'title'); trackBy: trackDecoration" [ngTemplateOutlet]="widgetDecoration" [ngTemplateOutletContext]="{ $implicit: decoration }"></ng-container>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="api.hasSlotBinding('primaryValue')" class="ml-auto min-w-0 text-right">
        <div *ngIf="api.showSlotLabels()" class="truncate text-xs font-normal text-slate-500">{{ api.slotColumnLabel('primaryValue') }}</div>
        <div class="mt-0.5 flex min-w-0 items-center justify-end gap-1.5 font-semibold text-slate-950" [ngStyle]="api.slotCellStyle(row, 'primaryValue')">
          <ng-container *ngFor="let decoration of api.slotLeftDecorations(row, 'primaryValue'); trackBy: trackDecoration" [ngTemplateOutlet]="widgetDecoration" [ngTemplateOutletContext]="{ $implicit: decoration }"></ng-container>
          <fa-icon *ngIf="api.slotIconName(row, 'primaryValue')" [icon]="api.slotIconProp(row, 'primaryValue')" class="shrink-0" [ngStyle]="api.slotIconStyle(row, 'primaryValue')"></fa-icon>
          <span class="min-w-0 truncate">{{ api.slotValue(row, 'primaryValue') }}</span>
          <span *ngIf="api.slotBadgeLabel(row, 'primaryValue') as primaryBadge" class="shrink-0 rounded-full px-1.5 py-0.5 text-[9px] font-semibold uppercase" [ngStyle]="api.slotBadgeStyle(row, 'primaryValue')">
            {{ primaryBadge }}
          </span>
          <ng-container *ngFor="let decoration of api.slotRightDecorations(row, 'primaryValue'); trackBy: trackDecoration" [ngTemplateOutlet]="widgetDecoration" [ngTemplateOutletContext]="{ $implicit: decoration }"></ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
